import React from 'react'
import PropTypes from 'prop-types'
import Modal from '@components/modal/modal'
import { MessageBox, Link, CustomStyle } from './modal-validation-style'
const ModalValidation = ({ isOpened, onClose }) => {
  return (
    <Modal className="modal-validation" title="Atenção" isOpened={isOpened} onClose={onClose} id="validation" removeCloseButton>
      <>
        <CustomStyle />
        <MessageBox>
          Pedimos que entre em contato pelo email <Link href="mailto:clientes@aberto.com.br">clientes@aberto.com.br</Link> para concluirmos seu
          cadastro informando sua <br />
          <strong>Razão Social</strong> e <strong>CNPJ</strong>. <br />
          Obrigado por escolher a Aberto.
        </MessageBox>
      </>
    </Modal>
  )
}

ModalValidation.propTypes = {
  isOpened: PropTypes.bool,
  onClose: PropTypes.func,
}
ModalValidation.displayName = 'ModalValidation'

export default ModalValidation
